// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5078dc66]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.pagination-wrapper[data-v-5078dc66]{display:flex;justify-content:flex-end;margin-top:20px}.editor-container[data-v-5078dc66]{width:550px;padding:0 20px 20px;height:100%}.editor-container .editor__content[data-v-5078dc66]{height:calc(100% - 52px)}.editor-container .normal-input[data-v-5078dc66]{width:275px}.tag[data-v-5078dc66]{margin:0 10px 10px 0}", ""]);
// Exports
module.exports = exports;
